



































import { Component, Prop, Vue } from 'vue-property-decorator';
import Toggle from '@/components/common/Toggle.vue';
import {
  languageToggles,
  difficultyToggles,
} from '@/utils/add-question/add-question-constant';
import { BuildQuestion } from '@/utils/add-question/add-question-util';

@Component({
  components: {
    Toggle,
  },
})
export default class BuildLangDiff extends Vue {
  @Prop()
  buildQuestion!: BuildQuestion;

  languageToggles = languageToggles;
  mainLanguageToggles = languageToggles.slice(0, 2);
  difficultyToggles = difficultyToggles;

  get initialLanguage() {
    if (this.buildQuestion.languages.length > 1) {
      // NOTE: Multi language selected
      return 2;
    } else {
      return this.mainLanguageToggles.findIndex(language => {
        return language.id === this.buildQuestion.languages[0];
      });
    }
  }

  get initialMainLanguage() {
    return languageToggles.findIndex(language => {
      return language.id === this.buildQuestion.languages[0];
    });
  }

  get initialDifficulty() {
    return difficultyToggles.findIndex(difficulty => {
      return difficulty.id === `${this.buildQuestion.difficulty}`;
    });
  }

  updateLanguage(index: number) {
    if (index === 2) {
      this.buildQuestion.languages = [
        this.languageToggles[0].id,
        this.languageToggles[1].id,
      ];
    } else {
      const selectedLanguage = this.languageToggles[index];
      this.buildQuestion.languages = [selectedLanguage.id];
    }
  }

  updateMainLanguage(index: number) {
    const selectedOption = this.mainLanguageToggles[index];
    const selectedIndex = this.buildQuestion.languages.findIndex(
      lang => lang === selectedOption.id,
    );

    if (selectedIndex !== 0) {
      const mainLanguage = this.buildQuestion.languages.pop();
      if (mainLanguage) {
        this.buildQuestion.languages.unshift(mainLanguage);
      }
    }
  }

  updateDifficulty(index: number) {
    const selectedDifficulty = this.difficultyToggles[index];
    this.buildQuestion.difficulty = Number(selectedDifficulty.id);
  }
}
